import React from "react";
import InvoiceItem from "./InvoiceItem";

const InvoiceItems = (props) => {
  return (
    <>
      {props.panel && (
        <>
          <div
            id={"invoice-items-panel-" + props.invoice.id}
            className="inb-c-item-details inb-c-order-reservations row"
          >
            <InvoiceItem
              positions={props.invoice.extern_invoices_positions}
              id={props.invoice.id}
              invoice={props.invoice}
              dispatch={props.data.dispatch}
            />
          </div>
        </>
      )}
      {!props.panel && (
        <InvoiceItem
          positions={props.invoice.extern_invoices_positions}
          id={props.invoice.id}
          invoice={props.invoice}
          dispatch={props.data.dispatch}
        />
      )}
    </>
  );
};

export default InvoiceItems;
